module.exports = __webpack_public_path__ + "img/mc171.8bdb65d2.jpg";